import ProgressBar, { type ProgressProps } from './progress-bar';

export { variants } from './style';
export type { ProgressProps };
export default ProgressBar;
